import { SignalWifiStatusbarNull, Wifi, Wifi1Bar, Wifi2Bar } from '@mui/icons-material'
import { useTheme } from '@mui/material'

import { NoSignalIcon, SignalIcon, UnknownBubble } from '../data-icons'

const SignalIndicatorBubble = ({ value, isOffline, nodeTypeName }: { value: number; isOffline: boolean; nodeTypeName?: string }) => {
  const theme = useTheme()

  const offlineText = isOffline ? ' (Offline)' : ''

  const { ariaLabel, IconComponent } = {
    0: { ariaLabel: 'No signal', IconComponent: NoSignalIcon },
    1: { ariaLabel: 'Weak signal', IconComponent: SignalIcon },
    2: { ariaLabel: 'Weak signal', IconComponent: SignalIcon },
    3: { ariaLabel: 'Fair signal', IconComponent: SignalIcon },
    4: { ariaLabel: 'Good signal', IconComponent: SignalIcon },
    5: { ariaLabel: 'Excellent signal', IconComponent: SignalIcon },
  }[value] ?? { ariaLabel: 'Unknown', IconComponent: UnknownBubble }

  if (nodeTypeName !== 'kerlink_wifi_gateway')
    return (
      <IconComponent
        value={value}
        isOffline={isOffline}
        htmlColor={isOffline ? theme.palette.divider : theme.palette.text.primary}
        aria-label={`${ariaLabel}${offlineText}`}
      />
    )
  return (
    <>
      {value < 0 && <UnknownBubble htmlColor={isOffline ? theme.palette.divider : theme.palette.text.primary} aria-label={`Unknown${offlineText}`} />}
      {value === 0 && <SignalWifiStatusbarNull htmlColor={theme.palette.divider} aria-label={`${ariaLabel}${offlineText}`} />}
      {value === 1 && <Wifi1Bar htmlColor={theme.palette.success.light} aria-label={`${ariaLabel}${offlineText}`} />}
      {value === 2 && <Wifi2Bar htmlColor={theme.palette.success.light} aria-label={`${ariaLabel}${offlineText}`} />}
      {value === 3 && <Wifi2Bar htmlColor={theme.palette.success.light} aria-label={`${ariaLabel}${offlineText}`} />}
      {value === 4 && <Wifi htmlColor={theme.palette.success.light} aria-label={`${ariaLabel}${offlineText}`} />}
      {value === 5 && <Wifi htmlColor={theme.palette.success.light} aria-label={`${ariaLabel}${offlineText}`} />}
    </>
  )
}

export default SignalIndicatorBubble
